<div class="card card-shadow">
    <div class="card-body">
        <div class="nav-scroller py-1 mb-2">
            <nav class="d-flex justify-content-between">
                <span class="mx-2">
                    <img alt="IC Logo" class="opacity-90" src="/assets/img/logo/f_01.png" style="height:55px;">
                </span>
                <span class="mx-2">
                    <img alt="Year of Celebrating The Mahatma" class="opacity-90" src="/assets/img/logo/f_02.png"
                        style="height:55px;">
                </span>
                <span class="mx-2">
                    <img alt="Vibrant Gujarat 2019" class="opacity-90" src="/assets/img/logo/f_03.png"
                        style="height:55px;">
                </span>
                <span class="mx-2">
                    <img alt="IFP Portal" class="opacity-90" src="/assets/img/logo/f_04.png" style="height:55px;">
                </span>
                <span class="mx-2">
                    <img alt="Make in india" class="opacity-90" src="/assets/img/logo/f_05.png" style="height:55px;">
                </span>
                <span class="mx-2">
                    <img alt="Statue of Unity" class="opacity-90" src="/assets/img/logo/f_06.png" style="height:55px;">
                </span>
            </nav>
        </div>
    </div>
</div>